/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const editCustomerKnownNumberBodyNumberMax = 80;

export const editCustomerKnownNumberBodyExpectedCustomerVersionExclusiveMin = 0;
export const editCustomerKnownNumberBodyExpectedCustomerVersionMax = 9007199254740991;

export const EditCustomerKnownNumberBody = zod.object({
  number: zod.string().min(1).max(editCustomerKnownNumberBodyNumberMax),
  expectedCustomerVersion: zod
    .int()
    .gt(editCustomerKnownNumberBodyExpectedCustomerVersionExclusiveMin)
    .max(editCustomerKnownNumberBodyExpectedCustomerVersionMax),
});

export type EditCustomerKnownNumberBody = zod.input<typeof EditCustomerKnownNumberBody>;
export type EditCustomerKnownNumberBodyOutput = zod.output<typeof EditCustomerKnownNumberBody>;
